module.exports = __webpack_public_path__ + "img/product_pressalit_bathe02.a370cd15.jpg";